var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m6.348 7.753 7.766-4.457C13.956 2.53 14.14 1 16.14 1c1.901 0 1.896 1.161 1.89 2.263v.168L26 7.754c.877-.203 2.822-.338 3.578.743.756 1.08-.45 2.476-1.148 3.038v8.847c.765.609 1.931 2.364 1.013 3.445-.919 1.08-2.409.45-3.107.135l-8.103 4.39c.135.787 0 2.417-1.62 2.633-1.621.216-2.072-1.666-2.094-2.634l-8.172-4.39c-.54.405-1.985 1.107-2.904.135-.918-.972-.202-3.174.675-3.58v-8.98c-.586-.36-1.58-1.473-.878-3.04.702-1.566 2.363-1.147 3.106-.742zm10.67-3.512-1.756 6.754 5.672 3.647 5.132-5.401-9.049-4.999zM7.766 8.7l5.402 1.62 1.486-5.536-6.888 3.916zm7.496 4.39 4.186 2.498-4.794 3.242.608-5.74zm11.48-1.486-3.85 3.984 3.512 3.984.338-7.968zm-5.808 5.47c2.229 1.418 6.442 4.403 5.47 4.997-.972.593-6.888 3.758-9.724 5.266l-2.026-6.347 6.28-3.918zm-7.428 4.457c.27-.11.878 3.375 1.148 5.13L8.24 23.15c1.642-.496 4.996-1.513 5.266-1.621zm-6.618-.001-1.215-.541v-9.996l1.215-.675 6.28 1.89.338 7.023-1.08.743-5.538 1.553z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiot);
export default __webpack_public_path__ + "static/media/BIOT.963dd8ed3917d3d1e399550b59b86ef3.svg";
export { ForwardRef as ReactComponent };